(function (global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.Carousel = global.NewHomeSource.Carousel || {};

  const Carousel = global.NewHomeSource.Carousel;

  if (!global.NewHomeSource.Helpers ||
      !global.NewHomeSource.Helpers.Array ||
      !Carousel.Limit) {
    return;
  }

  const arrayHelper = global.NewHomeSource.Helpers.Array;

  class ScrollLimit {
    /**
     * Initializes a new instance of the class.
     * Sets the initial state to null.
     */
    constructor() {
      this.state = null;
    }

    /**
     * Initializes the object with the provided state.
     *
     * @param {Object} state - The state object to initialize with.
     * @returns {this} The current instance for chaining.
     */
    initialize(state) {
      this.state = state;
      return this;
    }

    /**
     * Calculates and returns the scroll limit for the carousel based on the current state.
     *
     * @returns {Carousel.Limit} The initialized scroll limit object.
     */
    get() {
      const contentSize = this.state.get('contentSize');
      const scrollSnaps = this.state.get('scrollSnaps');
      const loop = this.state.get('loop');
      const max = scrollSnaps[0];
      const min = loop ? max - contentSize : arrayHelper.arrayLast(scrollSnaps);
      const limit = new Carousel.Limit();
      limit.initialize(min, max);

      return limit;
    }
  }

  global.NewHomeSource.Carousel.ScrollLimit = ScrollLimit;
}(window));
